export default __webpack_public_path__ + "static/media/checkbox-unchecked.ed6f995b.svg";